import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { THEMES } from '../../../../configs/LayoutConfig';
import { formatPercent, formatValueBillion } from '../../../helpers/Text';
import ConstChart from '../../../common/mixChart/Const';
import ChartCommon from '../../../common/mixChart/MixChart';
import { NUMBER_FLEXIBLE } from '../Const';
import {
  generateChartConfig,
  SETTINGS,
  incomeStatementInsuranceMapping,
} from './InsuranceConst';

class BankingChart extends PureComponent {
  getData = () => {
    const { dataByIds } = this.props;
    const fields = this.getFields();
    return [...Array(5)].reduce((result, _, index) => {
      const hasData =
        dataByIds[
          incomeStatementInsuranceMapping.netRevenueOfInsurancePremium
        ] &&
        dataByIds[
          incomeStatementInsuranceMapping
            .netOperatingProfitFromInsuranceOperation
        ] &&
        dataByIds[incomeStatementInsuranceMapping.netProfitLossAfterTax] &&
        dataByIds[incomeStatementInsuranceMapping.netProfitMargin];
      if (fields[index] && hasData) {
        return result.concat({
          netRevenueOfInsurancePremium: formatValueBillion(
            dataByIds[
              incomeStatementInsuranceMapping.netRevenueOfInsurancePremium
            ][fields[index].key],
          ),
          netOperatingProfitFromInsuranceOperation: formatValueBillion(
            dataByIds[
              incomeStatementInsuranceMapping
                .netOperatingProfitFromInsuranceOperation
            ][fields[index].key],
          ),
          netProfit: formatValueBillion(
            dataByIds[incomeStatementInsuranceMapping.netProfit][
              fields[index].key
            ],
          ),
          netProfitMargin: formatPercent(
            dataByIds[incomeStatementInsuranceMapping.netProfitMargin][
              fields[index].key
            ],
          ),
          time: this.getFieldTitle(fields[index]),
        });
      }

      return result;
    }, []);
  };

  getFieldTitle = item => {
    const { timeKey } = this.props;
    const key =
      timeKey === 'yearly'
        ? 'financialStatement.yearName'
        : 'financialStatement.quarterName';
    return I18n.t(key, {
      quarter: item.quarter,
      year: item.year,
    });
  };

  getFields = () => {
    const { numberColumn } = this.props;
    const finalColumn = Math.min(numberColumn, NUMBER_FLEXIBLE);
    const { fields, skip } = this.props;
    if (fields.length - skip - finalColumn < 0) {
      return fields.slice(0, finalColumn);
    }

    return fields.slice(
      fields.length - skip - finalColumn,
      fields.length - skip,
    );
  };

  getConfigChart = () => {
    const { theme } = this.props;
    const {
      COLUMN_ONE_COLOR,
      COLUMN_TWO_COLOR,
      COLUMN_THREE_COLOR,
      COLUMN_FOUR_COLOR,
    } = SETTINGS[theme];
    const tooltips = [
      {
        i18nKey:
          'financialStatement.incomeStatementChart.netRevenueOfInsurancePremiumTooltip',
        key: 'netRevenueOfInsurancePremium',
      },
      {
        i18nKey:
          'financialStatement.incomeStatementChart.netOperatingProfitFromInsuranceOperationTooltip',
        key: 'netOperatingProfitFromInsuranceOperation',
      },
      {
        i18nKey: 'financialStatement.incomeStatementChart.netProfitTooltip',
        key: 'netProfit',
      },
      {
        i18nKey:
          'financialStatement.incomeStatementChart.netProfitMarginTooltip',
        key: 'netProfitMargin',
      },
    ];

    const listLegendChart = [
      ConstChart.setLegendConfig(
        ConstChart.GROUPCHART,
        I18n.t('financialStatement.netRevenueOfInsurancePremium'),
        COLUMN_ONE_COLOR,
      ),
      ConstChart.setLegendConfig(
        ConstChart.BARCHART,
        I18n.t('financialStatement.netOperatingProfitFromInsuranceOperation'),
        COLUMN_TWO_COLOR,
      ),
      ConstChart.setLegendConfig(
        ConstChart.BARCHART,
        I18n.t('financialStatement.incomeStatementChart.netProfit'),
        COLUMN_THREE_COLOR,
      ),
      ConstChart.setLegendConfig(
        ConstChart.CIRCLEMARKERLINE,
        I18n.t('financialStatement.incomeStatementChart.netProfitMargin'),
        COLUMN_FOUR_COLOR,
      ),
    ];

    return generateChartConfig({
      tooltips,
      listLegendChart,
      title: {
        title: I18n.t('financialStatement.incomeStatementChart.profitAndLoss'),
      },
      theme,
    });
  };

  render() {
    const { width, locale } = this.props;
    if (!width) {
      return null;
    }

    return (
      <div className="income-statement-chart">
        <ChartCommon
          key={locale}
          configChart={this.getConfigChart()}
          data={this.getData()}
          width={width - 40}
          ratio={window.devicePixelRatio}
        />
      </div>
    );
  }
}

BankingChart.propTypes = {
  skip: PropTypes.number.isRequired,
  fields: PropTypes.array.isRequired,
  dataByIds: PropTypes.object.isRequired,
  width: PropTypes.number,
  locale: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
};

const mapStateToProps = ({ theme }) => ({ theme });

export default connect(mapStateToProps)(BankingChart);
